import ControlViewModel from '@/ViewModels/ControlViewModel';
import ComponentManager from '@/Management/ComponentManager';
import DetailViewContext from '@/ViewModels/Contexts/DetailViewContext';
import * as CoreFrameDTOs from "coreframetypings/dto";

export default class DetailViewGroupBoxViewModel extends ControlViewModel {

    /**
     * Der Kontext des ViewModels
     */
    public context: DetailViewContext;

    /**
     * Definiert den Namen des inneren Layouts
     */
    public layout: string;

    /**
     * Enthält die inneren DetailViewGroups
     */
    public detailViewGroups: Array<CoreFrameDTOs.IDetailViewGroupDTO>;
    
    /**
     * Das ViewModel für die DetailViewGroupBox
     * @param {object} params - Ein Objekt mit Optionen für das Control
     * @constructor
     */
    public constructor(params: any) {
        super(params);

        this.context = this.paramOrDefault(params.context, null);
        this.layout = this.paramOrDefault(params.layout, 'NoneLayout');
        this.detailViewGroups = this.paramOrDefault(params.detailViewGroups, []);
    }
}

ComponentManager.setViewModel('DetailViewGroupBoxViewModel', DetailViewGroupBoxViewModel, 'RADPresentation.HTMLClient.DefaultViewExtensions');